import $ from 'jquery';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

export const bindTextLinkClickTrackingEvents = (wrapperNodeRef, linkSelector, eventId) => {
  $(wrapperNodeRef).find(linkSelector).each(function(index, element){
    var $elem = $(element);
    $elem.unbind(`click.${eventId}`).bind(`click.${eventId}`, (e)=>{
      getTracker().handleTextLinkClick(e);
    });
  });
};
